<script lang="ts">
  import AboutModal from "./AboutModal.svelte";
  import Header from "./Header.svelte";
  import Tiers from "./Tiers.svelte";
  import AppliedDealDetails from "./AppliedDealDetails.svelte";
  import TierProductsTable from "./TierProductsTable.svelte";
  import { OnLayoutChange } from "@shared/svelte/Directives/OnLayoutChange.js";
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import * as _ from "lodash";
  import { DISCOUNT_AMOUNT_TYPES } from "@shared/types/Deals";
  import type { Discount, DealTier } from "@shared/types/Deals";
  import type { Product } from "@shared/types/ProductLine";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { DealTierDescriptionEntity } from "@shared/services/event_tracking/entities";

  export let deal: DealTier[];
  export let products: { [key: number]: Product };
  export let dealTierId: number;

  const { trackEvent } = EventTracking;
  let layoutName;
  function updateLayoutName(name) {
    layoutName = name;
  }

  let nextDealTier;
  let dealTier: DealTier;
  if (dealTierId) {
    dealTier = deal.find(t => t.deal_tier_id == dealTierId);
  } else {
    dealTier = deal[0];
    dealTierId = dealTier.deal_tier_id;
  }

  let myTierIndex = deal.findIndex(t => t.deal_tier_id == dealTierId);
  if (deal[myTierIndex + 1]) {
    nextDealTier = deal[myTierIndex + 1];
  }

  let showAboutModal = false;
  let productsCount = dealTier?.discounts.length || 0;
  let dealActive =
    dealTier.active_deal && dealTier.discounts.some((d: Discount) => d.active_discount);

  let productTracked = {};
  for (const discount of dealTier.discounts) {
    if (!productTracked[discount.product_id]) {
      const entities = new DealTierDescriptionEntity({
        product_id: discount.product_id,
        deal_tier_id: dealTier.deal_tier_id,
        distributor_id: dealTier.distributor_id,
        product_group_id: null,
        sku: null,
      });
      trackEvent("begin_to_render", [entities]);
      productTracked[discount.product_id] = 1;
    }
  }

  function openModal() {
    showAboutModal = true;
  }

  function closeModal() {
    showAboutModal = false;
  }

  let isRip: boolean;
  if (deal[0].discounts[0].amount_type === DISCOUNT_AMOUNT_TYPES.RIP) isRip = true;
</script>

<div class="fizz-styles">
  <AboutModal bind:showAboutModal {closeModal} {isRip} />

  <div class="fizz-layout-header-main">
    <Header {openModal} {dealTier} {isRip} />
    {#if deal.length > 1}
      <Tiers {deal} dealTierId={dealTier.deal_tier_id} {isRip} />
    {/if}

    <main data-grid-area="main">
      <section
        class="fizz-space-between fizz-text-small fizz-surface fizz-inset-squish-24 fizz-border-bottom fizz-text-medium"
        use:OnLayoutChange={updateLayoutName}
        style={layoutName == "mobile" ? "position: sticky; top: 105px; z-index: 200;" : ""}
      >
        <p>{productsCount} {pluralize("Product", productsCount)}</p>
        {#if dealActive}
          <AppliedDealDetails {nextDealTier} {dealTier} />
        {/if}
      </section>
      <TierProductsTable {dealTier} {dealActive} {products} {isRip} />
    </main>
  </div>
</div>
